import { render, staticRenderFns } from "./alert-banner.component.vue?vue&type=template&id=c7ccdb42&"
import script from "./alert-banner.component.vue?vue&type=script&lang=ts&"
export * from "./alert-banner.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports